import { unwrap } from 'api/schema/utils';
export default function parseWarehouseReleaseModelVariants(data) {
    var _a;
    const uniqueCorrespondinSizes = (data === null || data === void 0 ? void 0 : data.sizes) ? (_a = findUnique(unwrap(data === null || data === void 0 ? void 0 : data.sizes), e => { var _a; return (_a = e.correspondingSize) === null || _a === void 0 ? void 0 : _a.id; })) === null || _a === void 0 ? void 0 : _a.map(e => e.correspondingSize) : [];
    const uniqueCorrespondingColors = (data === null || data === void 0 ? void 0 : data.colors) ? findUnique(unwrap(data === null || data === void 0 ? void 0 : data.colors), e => { var _a; return (_a = e.correspondingColor) === null || _a === void 0 ? void 0 : _a.id; }).map(e => e.correspondingColor) : [];
    const specificationVariants = unwrap(data === null || data === void 0 ? void 0 : data.variants) || [];
    const variants = uniqueCorrespondingColors.map(color => ({
        colorName: color.name, quantities: uniqueCorrespondinSizes.map(size => specificationVariants.find((variant) => {
            var _a, _b, _c, _d;
            return ((_b = (_a = variant === null || variant === void 0 ? void 0 : variant.warehouseReleaseModelColor) === null || _a === void 0 ? void 0 : _a.correspondingColor) === null || _b === void 0 ? void 0 : _b.id) === (color === null || color === void 0 ? void 0 : color.id) &&
                ((_d = (_c = variant === null || variant === void 0 ? void 0 : variant.warehouseReleaseModelSize) === null || _c === void 0 ? void 0 : _c.correspondingSize) === null || _d === void 0 ? void 0 : _d.id) === size.id;
        }))
    }));
    return {
        variants,
        colors: uniqueCorrespondingColors,
        sizes: uniqueCorrespondinSizes,
    };
}
function findUnique(list, keyGetter) {
    const set = new Set();
    return list.filter(item => {
        const key = keyGetter(item);
        const isNew = !set.has(key);
        if (isNew) {
            set.add(key);
        }
        return isNew;
    });
}
